<template>
	<div class="page page-home">
		<MeetModal v-if="city == 1" @resetCity="city = 0" video="552793730" event="karta_video_seul" event_m="m_karta_video_seul">
			<template v-slot:title>
				Сеул
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/seul.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Cтолица Республики Корея и ваша первая точка в путешествии по стране. В прекрасном городе органично сочетаются история и современность.</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/seul.mp3')" playerid="audio-player" event="karta_audio_seul" event_m="m_karta_audio_seul" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-11.jpg" alt="">
			</template>
		</MeetModal>
		<MeetModal v-if="city == 2" @resetCity="city = 0" video="552793414" event="karta_video_chondzhu" event_m="m_karta_video_chondzhu">
			<template v-slot:title>
				Чонджу
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/chonju.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Это столица корейской провинции Чолла-Пукто, жемчужина Азии! Здесь можно посетить настоящие корейские деревни и увидеть домики с выгнутыми крышами, чайные дома и мастерские.</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/chonjy.mp3')" playerid="audio-player" event="karta_audio_chondzhu" event_m="m_karta_audio_chondzhu" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-13.jpg" alt="">
			</template>
		</MeetModal>
		<MeetModal v-if="city == 3" @resetCity="city = 0" video="552792995" event="karta_video_mokpho" event_m="m_karta_video_mokpho">
			<template v-slot:title>
				Мокпхо
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/mokpho.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Город на юго-западе, на берегу Желтого моря. Это порт, памятник архитектуры и природный феномен. Город окружён островами — это спасает его от штормов и цунами.</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/mokpho.mp3')" playerid="audio-player" event="karta_audio_mokpho" event_m="m_karta_audio_mokpho" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-14.jpg" alt="">
			</template>
		</MeetModal>
		<MeetModal v-if="city == 4" @resetCity="city = 0" video="552792533" event="karta_video_kannyn" event_m="m_karta_video_kannyn">
			<template v-slot:title>
				Каннын
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/kannyn.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Город прекрасных пляжей, фестивалей и спорта на берегу Восточного моря. Его очень любят туристы Кореи и всего мира.</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/kannym.mp3')" playerid="audio-player" event="karta_audio_kannyn" event_m="m_karta_audio_kannyn" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-15.jpg" alt="">
			</template>
		</MeetModal>
		<MeetModal v-if="city == 5" @resetCity="city = 0" video="552792196" event="karta_video_andon" event_m="m_karta_video_andon">
			<template v-slot:title>
				Андон
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/andon.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Столица провинции Кёнсан-Пукто, культурный и духовный центр Кореи. В прошлом здесь находился центр конфуцианства.</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/andon.mp3')" playerid="audio-player" event="karta_audio_andon" event_m="m_karta_audio_andon" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-16.jpg" alt="">
			</template>
		</MeetModal>
		<MeetModal v-if="city == 6" @resetCity="city = 0" video="552793279" event="karta_video_pusan" event_m="m_karta_video_pusan">
			<template v-slot:title>
				Пусан
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/pusan.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Второй по величине город после Сеула. Много воды, много людей, пляжи, горы и храмы. Его даже называли перекрёстком Земли!</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/pusan.mp3')" playerid="audio-player" event="karta_audio_pusan" event_m="m_karta_audio_pusan" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-12.jpg" alt="">
			</template>
		</MeetModal>
		<MeetModal v-if="city == 7" @resetCity="city = 0" video="552793575" event="karta_video_chedzhu" event_m="m_karta_video_chedzhu">
			<template v-slot:title>
				Чеджудо
			</template>
			<template v-slot:image>
				<img src="../assets/images/cities/chedjudo.jpg" alt="">
			</template>
			<template v-slot:text>
				<p>Самый большой остров Южной Кореи. Он возник после извержений вулканов. На Чеджудо очень тепло. В субтропическом климате растут редкие растения: например, гибискусы и камелии.</p>
				<p>Продолжение в рассказе Хеён:</p>
			</template>
			<template v-slot:audio>
				<Audio :url="require('../assets/audio/chedjudo.mp3')" playerid="audio-player" event="karta_audio_chedzhu" event_m="m_karta_audio_chedzhu" />
			</template>
			<template v-slot:video>
				<img src="../assets/images/image-17.jpg" alt="">
			</template>
		</MeetModal>
		<Social socialWhite="social--white" />
		<Header headerWhite="header--white" @goto="goToSectoion" @toggleMenu="menu = !menu" :menu="menu" :active="activeScreen" />
		<full-page ref="fullpage" :options="options" id="fullpage">
			<div class="section fp-noscroll" id="1">
				<div class="main" id="main">
					<QuizButton mainButton="button--main" @goto="goToSectoion" />
					<div class="main__pattern"></div>
					<div class="container">
						<div class="main__content">
							<div class="main__title">
								<span class="color-red">K</span><span class="color-yellow">-</span><span class="color-blue">T</span><span class="color-purpure">R</span><span class="color-red">A</span><span class="color-yellow">V</span><span class="color-blue">E</span><span class="color-purpure">L</span> <br><span class="color-white">FEST 2021:</span>
							</div>
							<div class="main__subtitle">Фестиваль туризма Кореи</div>
							<!-- <div class="main__contest">
								<div class="main__contest-title">Участвуйте в конкурсах</div>
								<div class="main__contest-list">
									<div class="main__contest-item main__contest-item--yellow" @click="scrollTo('contest-1')">Конкурс 1</div>
									<div class="main__contest-item main__contest-item--purpure" @click="scrollTo('contest-2')">Конкурс 2</div>
									<div class="main__contest-item main__contest-item--blue" @click="scrollTo('contest-3')">Конкурс 3</div>
								</div>
							</div> -->
							<div class="main__text">Республика Корея – очаровательная страна, завораживающая природной красотой, памятниками древности и многообразным городским колоритом. Уже более 30 лет наши страны развивают дружеские отношения и добрососедское партнерство. <br>Мы рады пригласить вас на онлайн-фестиваль Национальной организации туризма Кореи. Путешествуйте по фестивалю и выигрывайте призы: смарт-часы, смартфоны и даже поездку в Корею!</div>
						</div>
					</div>
				</div>
			</div>
			<div class="section fp-auto-height">
				<Lines class="static" />
				<div class="welcome">
					<div class="container">
						<div class="welcome__content">
							<div class="welcome__avatar">
								<img src="../assets/images/avatar.png" alt="">
							</div>
							<div class="welcome__info">
								<div class="welcome__title">Добро пожаловать на <span class="color-red">Фестиваль</span> <span class="color-yellow">Туризма</span> <span class="color-blue">Кореи!</span> <br>Меня зовут <span class="color-purpure">Хеён!</span> Я из Южной Кореи и буду вашим гидом на этом фестивале.</div>
								<div class="welcome__text">Этот фестиваль мы проводим совместно с Национальной организацией туризма Кореи <br>и он приурочен к годам взаимных обменов между Россией и Кореей. Корея - это смесь <br>современной и традиционной культуры, и я уверена, здесь каждый сможет найти себе что-то по душе.</div>
								<div class="audio">
									<Audio :url="require('../assets/audio/hello.mp3')" playerid="audio-player" event="Audio_blogger" event_m="m_Audio_blogger" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="section fp-noscroll">
				<Lines class="static" />
				<div :class="`list list--${hoverCity}`" id="know">
					<div class="list__content" id="3">
						<a href="javascript:void(0)" class="list__item" @click="startAnim('vr')" @mouseenter="hoverCity = 1">
							<div class="list__item-title">Полное погружение</div>
							<div class="list__item-subtitle">VR-туры</div>
							<div class="list__item-link">
								<span>Подробнее</span>
							</div>
						</a>
						<a href="javascript:void(0)" class="list__item" @click="startAnim('rhythm')" @mouseenter="hoverCity = 2">
							<div class="list__item-title">Держи ритм!</div>
							<div class="list__item-subtitle">Регионы Кореи</div>
							<div class="list__item-link">
								<span>Подробнее</span>
							</div>
						</a>
						<a href="javascript:void(0)" class="list__item" @click="startAnim('tropa')" @mouseenter="hoverCity = 3">
							<div class="list__item-title">Пройдись <br>по тропе истории</div>
							<div class="list__item-subtitle">Культурное наследие </div>
							<div class="list__item-link">
								<span>Подробнее</span>
							</div>
						</a>
						<a href="javascript:void(0)" class="list__item" @click="startAnim('chudo')" @mouseenter="hoverCity = 4">
							<div class="list__item-title">Чудеса природы</div>
							<div class="list__item-subtitle">Природное наследие</div>
							<div class="list__item-link">
								<span>Подробнее</span>
							</div>
						</a>
					</div>
				</div>
			</div>
			<div class="section fp-noscroll" id="4">
				<div class="meet" id="map">
					<div class="container">
						<div class="meet__title">Познакомьтесь с Кореей</div>
						<div class="meet__subtitle">Выберите регион, чтобы узнать о нем больше</div>
						<div class="meet__map">
							<div class="meet__content">
								<div class="meet__column">
									<transition name="fade-left">
										<a href="javascript:void(0)" class="meet__item meet__item--1" @click="city = 1" v-if="activeScreen == 3" style="transition-delay: 300ms">
											<div class="meet__item-image">
												<img src="../assets/images/meet-1.jpg" alt="">
											</div>
											<div class="meet__item-title">Сеул</div>
										</a>
									</transition>
									<transition name="fade-left">
										<a href="javascript:void(0)" class="meet__item meet__item--2" @click="city = 2" v-if="activeScreen == 3" style="transition-delay: 600ms">
											<div class="meet__item-image">
												<img src="../assets/images/meet-2.jpg" alt="">
											</div>
											<div class="meet__item-title">Чонджу</div>
										</a>
									</transition>
									<transition name="fade-left">
										<a href="javascript:void(0)" class="meet__item meet__item--3" @click="city = 3" v-if="activeScreen == 3" style="transition-delay: 800ms">
											<div class="meet__item-image">
												<img src="../assets/images/meet-3.jpg" alt="">
											</div>
											<div class="meet__item-title">мокпхо</div>
										</a>
									</transition>
								</div>
								<div class="meet__column">
									<transition name="fade-right">
									<a href="javascript:void(0)" class="meet__item meet__item--4" @click="city = 4" v-if="activeScreen == 3" style="transition-delay: 200ms">
										<div class="meet__item-image">
											<img src="../assets/images/meet-4.jpg" alt="">
										</div>
										<div class="meet__item-title">Каннын</div>
									</a>
									</transition>
									<transition name="fade-right">
									<a href="javascript:void(0)" class="meet__item meet__item--5" @click="city = 5" v-if="activeScreen == 3" style="transition-delay: 500ms">
										<div class="meet__item-image">
											<img src="../assets/images/meet-5.jpg" alt="">
										</div>
										<div class="meet__item-title">Андон</div>
									</a>
									</transition>
									<transition name="fade-right">
									<a href="javascript:void(0)" class="meet__item meet__item--6" @click="city = 6" v-if="activeScreen == 3" style="transition-delay: 700ms">
										<div class="meet__item-image">
											<img src="../assets/images/meet-6.jpg" alt="">
										</div>
										<div class="meet__item-title">Пусан</div>
									</a>
									</transition>
									<transition name="fade-right">
									<a href="javascript:void(0)" class="meet__item meet__item--7" @click="city = 7" v-if="activeScreen == 3" style="transition-delay: 900ms">
										<div class="meet__item-image">
											<img src="../assets/images/meet-7.jpg" alt="">
										</div>
										<div class="meet__item-title">Чеджудо</div>
									</a>
									</transition>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="section">
				<div class="prizes" id="contest" ref="contest" @wheel="scrollBlock">
					<div class="prizes__top" id="contest-1">
						<div class="container">
							<div class="prizes__main">
								<transition  name="fade-left">
									<div v-if="scrollTop > 0">
										<div class="prizes__main-video" v-if="!videoPlay" @click="playVideo">
											<img src="../assets/images/prizes.jpg" alt="">
										</div>
										<div class="prizes__main-video prizes__main-video--play" v-else>
											<youtube video-id="bmp_tThqZxg" ref="youtube1"></youtube>
										</div>
									</div>
								</transition>
								<div class="prizes__main-content">
									<div class="prizes__main-title">Участвуй в конкурсах и постарайся выиграть один из замечательных призов!</div>
									<div class="prizes__main-text">Страна Утренней Свежести ждет! Смотри видео, танцуй вместе с Кореей и получи шанс посетить эту страну (билеты на двоих!), а также прими участие в других конкурсах и попробуй выиграть один из трех смартфонов или одни из пяти смарт-часов. Пусть тебе повезет!</div>
								</div>
							</div>
							<!-- <div class="prizes__content">
								<div class="prizes__item prizes__item--1">
									<div class="prizes__item-image prizes__item-image--air">
										<img src="../assets/images/plane.png" alt="">
									</div>
									<div class="prizes__item-content">
										<transition  name="fade-left">
											<div class="prizes__item-label" v-if="scrollTop > 200">Конкурс 1:</div>
										</transition>
										<transition  name="fade-up">
											<div class="prizes__item-title" v-if="scrollTop > 200">Билеты в Корею на двоих!</div>
										</transition>
										<transition  name="fade-up">
											<div class="prizes__item-text" v-if="scrollTop > 200">Любишь танцевать и путешествовать? Выбери любой <a href="javascript:void(0)" style="color:#000" @click="startAnim('rhythm')">из танцев</a>, попробуй его повторить полностью или его отдельные движения, сними себя на видео, выложи ролик в своем аккаунте Instagram или TikTok и отметь троих друзей (аккаунт должен быть открыт). Не забудь про хэштег #ktravel2021. Жюри выберет самого зажигательного исполнителя, который получит билеты в Корею на двоих. Это можешь быть ты!</div>
										</transition>
									</div>
									<div class="prizes__steps">
										<transition  name="fade-right">
											<a href="javascript:void(0)" @click="startAnim('rhythm')" class="prizes__step prizes__step--1" v-if="scrollTop > 200">
												<div class="prizes__step-number">1</div>
												<div class="prizes__step-icon">
													<img src="../assets/img/step-1.svg" alt="">
												</div>
												<div class="prizes__step-text">Смотри, как танцует Корея!</div>
											</a>
										</transition>
										<transition  name="fade-right">
											<div class="prizes__step prizes__step--2" v-if="scrollTop > 200" style="transition-delay: 300ms">
												<div class="prizes__step-number">2</div>
												<div class="prizes__step-icon">
													<img src="../assets/img/step-2.svg" alt="">
												</div>
												<div class="prizes__step-text">Сможешь повторить? <br>Сними видео</div>
											</div>
										</transition>
										<transition  name="fade-right">
											<div class="prizes__step prizes__step--3" v-if="scrollTop > 200" style="transition-delay: 600ms">
												<div class="prizes__step-number">3</div>
												<div class="prizes__step-icon">
													<img src="../assets/img/step-3.svg" alt="">
												</div>
												<div class="prizes__step-text">Выложи в Instagram <br>или TikTok</div>
											</div>
										</transition>
									</div>
								</div>
							</div> -->
						</div>
					</div> 

					<Result id="5" />
					<!-- <div class="prizes__content prizes__content--purpure" id="contest-2">
						<div class="container">
							<div class="prizes__item prizes__item--2">
								<div class="prizes__item-image">
									<img src="../assets/images/phone.png" alt="">
								</div>
								<div class="prizes__item-content">
									<transition name="fade-left">
										<div class="prizes__item-label" v-if="scrollTop > 400">Конкурс 2:</div>
									</transition>
									<transition name="fade-up">
										<div class="prizes__item-title" v-if="scrollTop > 400">Смартфоны!</div>
									</transition>
									<transition name="fade-up">
										<div class="prizes__item-text" v-if="scrollTop > 400">Хочешь крутой корейский смартфон? <a href="javascript:void(0)" @click="goToMap">Выбери место в Корее</a>, куда ты хочешь поехать. Выложи скриншот карты в свой аккаунт Instagram с хэштегом #ktravel2021 и отметь троих друзей (аккаунт должен быть открыт). Жюри выберет три самых убедительных и креативных ответа, авторы которых получат новенькие смартфоны!</div>
									</transition>
								</div>
								<div class="prizes__steps">
									<transition name="fade-right">
										<div class="prizes__step prizes__step--1" v-if="scrollTop > 400">
											<div class="prizes__step-number">1</div>
											<div class="prizes__step-icon">
												<img src="../assets/img/step-4.svg" alt="">
											</div>
											<div class="prizes__step-text">Напиши о любимом месте<br> в Корее</div>
										</div>
									</transition>
									<transition name="fade-right">
										<div class="prizes__step prizes__step--2" v-if="scrollTop > 400" style="transition-delay: 300ms">
											<div class="prizes__step-number">2</div>
											<div class="prizes__step-icon">
												<img src="../assets/img/step-5.svg" alt="">
											</div>
											<div class="prizes__step-text">Сделай скриншот <br>карты с отметкой</div>
										</div>
									</transition>
									<transition name="fade-right">
										<div class="prizes__step prizes__step--3" v-if="scrollTop > 400" style="transition-delay: 600ms">
											<div class="prizes__step-number">3</div>
											<div class="prizes__step-icon">
												<img src="../assets/img/step-6.svg" alt="">
											</div>
											<div class="prizes__step-text">Выложи текст и скриншот<br> в Instagram </div>
										</div>
									</transition>
								</div>
							</div>
						</div>
					</div>
					<div class="prizes__content prizes__content--blue" id="contest-3">
						<div class="container">
							<div class="prizes__item prizes__item--3">
								<div class="prizes__item-image">
									<img src="../assets/images/swatch.png" alt="">
								</div>
								<div class="prizes__item-content">
									<transition name="fade-left">
										<div class="prizes__item-label" v-if="scrollTop > 800">Конкурс 3:</div>
									</transition>
									<transition name="fade-up">
										<div class="prizes__item-title" v-if="scrollTop > 800">Cмарт-часы!</div>
									</transition>
									<transition name="fade-up">
										<div class="prizes__item-text" v-if="scrollTop > 800">Любишь умные гаджеты? Зайди в Instagram Ленты.ру <a href="https://www.instagram.com/etolentaru/?hl=ru" target="_blank" @click="sendEvent('instagram_ssylka', 'm_instagram_ssylka')" >@etolentaru</a>, найди в актуальных сторис игру KoreaFest, отыщи лишний элемент на фото и выложи скриншот правильного ответа в сторис в своем Instagram (аккаунт должен быть открыт) с тегом <a href="https://www.instagram.com/etolentaru/?hl=ru" target="_blank" @click="sendEvent('instagram_ssylka', 'm_instagram_ssylka')" >@etolentaru</a> и #ktravel2021. Пятерых победителей определит случай – повезти может именно тебе!</div>
									</transition>
								</div>
								<div class="prizes__steps">
									<transition name="fade-right">
										<a href="https://www.instagram.com/etolentaru/?hl=ru" target="_blank" @click="sendEvent('instagram_kartinka1', 'm_instagram_kartinka1')" class="prizes__step prizes__step--1" v-if="scrollTop > 800">
											<div class="prizes__step-number">1</div>
											<div class="prizes__step-icon">
												<img src="../assets/img/step-7.svg" alt="">
											</div>
											<div class="prizes__step-text">Зайди в Instagram Ленты.ру</div>
										</a>
									</transition>
									<transition name="fade-right">
										<div class="prizes__step prizes__step--2" v-if="scrollTop > 800" style="transition-delay: 300ms">
											<div class="prizes__step-number">2</div>
											<div class="prizes__step-icon">
												<img src="../assets/img/step-8.svg" alt="">
											</div>
											<div class="prizes__step-text">Найди лишний элемент на фото</div>
										</div>
									</transition>
									<transition name="fade-right">
										<a href="https://www.instagram.com/etolentaru/?hl=ru" @click="sendEvent('instagram_kartinka2', 'm_instagram_kartinka2')" target="_blank" class="prizes__step prizes__step--3" v-if="scrollTop > 800" style="transition-delay: 600ms">
											<div class="prizes__step-number">3</div>
											<div class="prizes__step-icon">
												<img src="../assets/img/step-9.svg" alt="">
											</div>
											<div class="prizes__step-text">Выложи скриншот ответа в Instagram</div>
										</a>
									</transition>
								</div>
							</div>
						</div>
					</div> -->
					<div class="prizes__note">
						<div class="container">
							<div class="prizes__note-title">Условия и результаты конкурса</div>
							<div class="prizes__note-text">
								<p><strong>Конкурсные работы принимаются<span></span> с 01.06.21 по 30.06.21.</strong> <br>Победителя в конкурсе «Танцуй с Кореей» и троих победителей в конкурсе «Любимое место в Корее» <br>выберет жюри. Пятерых победителей в конкурсе «Найди лишний элемент» определит выбор генератора случайных чисел RandStuff.</p>
								<p>14.07.21 мы объявим победителей, результаты конкурса будут опубликованы на сайте проекта.</p>
								<p>Подробная информация об организаторе, правилах проведения конкурса, определении победителей конкурса и получении призов <a href="/rules.pdf"  @click="sendEvent('pravila_konkursa', 'm_pravila_konkursa')" target="_blank">здесь.</a></p>
							</div>
						</div>
					</div>
				</div>
				<Footer footerMain="footer--main" />
			</div>
		</full-page>
	</div>

</template>

<script>
	import Header from '@/components/Header'
	import QuizButton from '@/components/QuizButton'
	import Lines from '@/components/Lines'
	import Social from '@/components/Social'
	import Footer from '@/components/Footer'
	import Audio from '@/components/Audio'
	import MeetModal from '@/components/MeetModal'
	import Result from '@/components/Result'
	import vueVimeoPlayer from 'vue-vimeo-player'
	import VueYoutube from 'vue-youtube'
	import Vue from 'vue'
	import VueScrollTo from 'vue-scrollto'
	Vue.use(vueVimeoPlayer)
	Vue.use(VueScrollTo)
	Vue.use(VueYoutube)

	export default {
		data() {
			return {
				anim: false,
				city: 0,
				menu: false,
				hoverCity: 1,
				videoPlay: false,
				activeScreen: 1,
				scrollTop: 0,
				send_100: false,
				scrolls: {
					scroll_25: false,
					scroll_50: false,
					scroll_75: false,
					scroll_100: false,
				},
				options: {
					scrollingSpeed: 700,
					scrollOverflow: true,
					responsiveWidth: 1000,
					onLeave: this.onLeave,
					licenseKey: '8CF2D987-42B5463E-99932468-42A81BB3'
				}
			}
		},
		components: {
			Header,
			QuizButton,
			Lines,
			Social,
			Footer,
			Audio,
			MeetModal,
			Result,
		},
		methods: {
			scrollEvent() {
				var h = document.documentElement, 
						b = document.body,
						st = 'scrollTop',
						sh = 'scrollHeight';

				var precent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
				if (precent > 25 && !this.scrolls.scroll_25) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_home_scroll_25'});
					this.scrolls.scroll_25 = true;
				}
				if (precent > 50 && !this.scrolls.scroll_50) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_home_scroll_50'});
					this.scrolls.scroll_50 = true;
				}
				if (precent > 75 && !this.scrolls.scroll_75) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_home_scroll_75'});
					this.scrolls.scroll_75 = true;
				}
				if (precent > 95 && !this.scrolls.scroll_100) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'm_home_scroll_100'});
					this.scrolls.scroll_100 = true;
				}
			},
			sendEvent(event, eventMob) {
				if (window.innerWidth > 960) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': event});
				} else {
					this.$gtag.event('click', {event_category: 'link', 'event_label': eventMob});
				}
			},
			scrollBlock() {
				if (document.getElementById("5").getElementsByClassName("fp-scroller")[0]) {
					let val = document.getElementById("5").getElementsByClassName("fp-scroller")[0].computedStyleMap().get('transform')[0].y.value;
					if (val == 0  || val == 1) {
						this.scrollTop = 1;
					} else {
						this.scrollTop = Math.abs(val);
						this.$refs.fullpage.api.reBuild();
						if (this.scrollTop > 1000) {
							if (!this.send_100) {
								this.send_100 = true;
								this.$gtag.event('click', {event_category: 'link', 'event_label': 'home_scroll_100'});
							}
						}
					}
				}
			},
			startAnim(url) {
				if (url == 'vr') {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'VR_tury'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_VR_tury'});
					}
				}
				if (url == 'rhythm') {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'Regiony_Korei'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_Regiony_Korei'});
					}
				}
				if (url == 'tropa') {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'Kulturnoe_nasledie'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_Kulturnoe_nasledie'});
					}
				}
				if (url == 'chudo') {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'Prirodnoe_nasledie'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_Prirodnoe_nasledie'});
					}
				}
				this.$router.push(url)
				/*this.anim = true;
				setTimeout(() => {
					this.anim = false;
				},800)*/
			},
			goToSectoion(number) {
				if (window.innerWidth < 960) {
					this.menu = false;
					console.log(number);
					this.$scrollTo(document.querySelector(`[id='${number}']`), '1000ms')
				} else {
					this.$refs.fullpage.api.moveTo(number);
				}
			},
			scrollTo(section) {
				this.$scrollTo(document.querySelector(`[id='${section}']`), '1000ms')
			},
			goToMap() {
				if (window.innerWidth < 960) {
					this.$scrollTo(document.querySelector(`[id='4']`), '1000ms')
				} else {
					this.$refs.fullpage.api.moveTo(4);
				}
			},
			playVideo() {
				this.videoPlay = true;
				this.$nextTick(() => {
					this.$refs.youtube1.player.playVideo()
					if (window.innerWidth > 960) {
          this.$gtag.event('click', {event_category: 'link','event_label': 'video_bloggera'});
					} else {
          this.$gtag.event('click', {event_category: 'link','event_label': 'm_video_bloggera'});
					}
				});
			},
			onLeave(item, i) {
				if (i.index == 4) {
					if (this.scrollTop == 0) {
						this.scrollTop = 1;
					}
				}
				this.activeScreen = i.index;

				if (this.activeScreen == 2) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'home_scroll_25'});
				}
				if (this.activeScreen == 3) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'home_scroll_50'});
				}
				if (this.activeScreen == 4) {
					this.$gtag.event('click', {event_category: 'link', 'event_label': 'home_scroll_75'});
				}
			},
		},
		created () {
			window.addEventListener('scroll', this.scrollEvent);
		},
		destroyed () {
			window.removeEventListener('scroll', this.scrollEvent);
		},
		mounted() {
			this.$refs.fullpage.api.reBuild();
			if (window.innerWidth < 960) {
				this.activeScreen = 3;
				this.scrollTop = 99999;
				this.$refs.fullpage.api.destroy('all');
				if(window.location.hash && window.location.hash == '#konkurs') {
					setTimeout(() => {
						this.$scrollTo(document.querySelector('[id="contest"]'), '1000ms')
					}, 1000)
				}
			} else {
				if(window.location.hash && window.location.hash == '#konkurs') {
						this.$refs.fullpage.api.moveTo(5);
				}
			}
		},
		watch: {
			city(value) {
				if (value == 1) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_seul'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_seul'});
					}
				}
				if (value == 2) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_chondzhu'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_chondzhu'});
					}
				}
				if (value == 3) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_mokpho'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_mokpho'});
					}
				}
				if (value == 4) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_kannyn'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_kannyn'});
					}
				}
				if (value == 5) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_andon'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_andon'});
					}
				}
				if (value == 6) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_pusan'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_pusan'});
					}
				}
				if (value == 7) {
					if (window.innerWidth > 960) {
						this.$gtag.event('click', {event_category: 'link','event_label': 'karta_chedzhu'});
					} else {
						this.$gtag.event('click', {event_category: 'link','event_label': 'm_karta_chedzhu'});
					}
				}
			}
		}
	}
</script>

<style>
.fade-left-enter-active, .fade-left-leave-active {
	transition: all 1.5s;
}
.fade-left-enter, .fade-left-leave-to {
	opacity: 0;
	transform: translateX(-90px);
}

.fade-right-enter-active, .fade-right-leave-active {
	transition: all 1.5s;
}
.fade-right-enter, .fade-right-leave-to {
	opacity: 0;
	transform: translateX(90px);
}

.fade-up-enter-active, .fade-up-leave-active {
	transition: all 1.5s;
}
.fade-up-enter, .fade-up-leave-to {
	opacity: 0;
	transform: translateY(90px);
}
.bg-left-enter-active, .bg-left-leave-active {
	transition: all 1.5s;
}
.bg-left-enter, .bg-left-leave-to {
	opacity: 0;
	transform: translateX(90px);
}
.bg-right-enter-active, .bg-right-leave-active {
	transition: all 1.5s;
}
.bg-right-enter, .bg-right-leave-to {
	opacity: 0;
	transform: translateX(-90px);
}
</style>
<style lang="sass">
	.iScrollVerticalScrollbar
		display: none !important
	.section
		position: relative
		overflow: hidden
		@media screen and (max-width: 1000px)
			height: auto !important
	.fp-tableCell
		@media screen and (max-width: 1000px)
			height: auto !important
	.main
		height: 100vh
		min-height: vw(710px)
		background-image: url(../assets/images/main.jpg)
		background-size: cover
		background-repeat: no-repeat
		position: relative
		&__contest
			display: none
			font-family: 'Montserrat'
			@media screen and (max-width: 1000px)
				display: block
				width: 100vw
				height: vwm(127px)
				margin-left: vwm(-20px)
				margin-top: vwm(125px)
				position: absolute
				background-color: $red
				background-image: url(../assets/images/bg.png)
			&-title
				text-align: center
				color: #fff
				font-weight: 600
				font-size: vwm(24px)
				margin-top: vwm(16px)
			&-list
				display: flex
				justify-content: center
			&-item
				display: block
				width: vwm(112px)
				margin-left: vwm(5px)
				margin-right: vwm(5px)
				height: vwm(50px)
				line-height: vwm(50px)
				text-align: center
				color: #fff
				margin-top: vwm(17px)
				cursor: pointer
				font-size: vwm(16px)
				&--yellow
					background-color: $yellow
				&--blue
					background-color: $lightblue
				&--purpure
					background-color: $purpure
		@media screen and (max-width: 1000px)
			min-height: 100vh
			height: vwm(835px)
			background-size: 100vw
			background-color: $blue
			background-image: url(../assets/images/main-mob.jpg)
		&:after
			content: ''
			width: 100%
			height: vw(504px)
			position: absolute
			bottom: 0
			left: 0
			background: linear-gradient(180deg, rgba(23, 46, 86, 0) 0%, rgba(23, 46, 86, 0.9) 73.44%)
			@media screen and (max-width: 1000px)
				height: vwm(710px)
		&:before
			content: ''
			width: 100%
			height: vw(106px)
			position: absolute
			top: 0
			left: 0
			background: linear-gradient(180deg, rgba(23, 46, 86, 0.9) 25%, rgba(23, 46, 86, 0) 100%)
			@media screen and (max-width: 1000px)
				height: vwm(300px)
		&__pattern
			background-image: url(../assets/images/bg-light.png)
			background-size: cover
			width: 100%
			height: 100%
			background-repeat: no-repeat
			position: absolute
			z-index: 80
		&__content
			position: relative
			z-index: 90
			padding-top: vw(136px)
			width: 100%
			@media screen and (max-width: 1000px)
				padding-top: vwm(80px)
		&__title
			color: $white
			font-size: vw(125px)
			line-height: vw(135px)
			text-transform: uppercase
			text-shadow: 10px 10px 20px rgba(8, 58, 102, 0.2)
			font-family: 'Oswald'
			@media screen and (max-width: 1000px)
				font-size: vwm(79px)
				line-height: vwm(96px)
				margin-top: vwm(-11px)
				margin-left: vwm(-4px)
			.color-red
				color: $red
			.color-yellow
				color: $yellow
			.color-blue
				color: $lightblue
			.color-purpure
				color: $purpure
			.color-white
				padding-left: vw(53px)
				@media screen and (max-width: 1000px)
					padding-left: vwm(24px)
		&__subtitle
			font-size: vw(30px)
			font-family: 'Montserrat'
			letter-spacing: 0.12em
			color: $white
			margin-top: vw(28px)
			margin-left: vw(42px)
			@media screen and (max-width: 1000px)
				font-size: vwm(19px)
				margin-left: vwm(0px)
				margin-top: vwm(15px)
				letter-spacing: vwm(3px)
		&__text
			width: vw(632px)
			font-size: vw(14px)
			line-height: vw(24px)
			font-family: 'Montserrat'
			color: $white
			margin-left: auto
			margin-right: vw(61px)
			margin-top: vw(56px)
			letter-spacing: 0.14px
			@media screen and (max-width: 1000px)
				width: 95%
				margin-top: vwm(279px)
				font-size: vwm(14px)
				line-height: vwm(20.5px)
				letter-spacing: vwm(0.2px)
				margin-right: 0
				margin-left: 0
				br
					display: none
	.prizes
		position: relative
		overflow: hidden
		&__step
			text-decoration: none
			&-text
				@media screen and (max-width: 1000px)
					br
						display: none
		&__top
			background-color: $yellow
			padding-top: vw(108px)
			padding-bottom: vw(48px)
			@media screen and (max-width: 1000px)
				padding-bottom: vwm(56px)
		&__main
			display: flex
			padding-left: vw(140px)
			margin-bottom: vw(148px)
			@media screen and (max-width: 1000px)
				flex-direction: column-reverse
				padding-left: 0
				margin-bottom: 0
			&-video
				width: vw(661px)
				min-width: vw(661px)
				position: relative
				box-shadow: 20px 20px 20px rgba(34, 81, 121, 0.2)
				cursor: pointer
				@media screen and (max-width: 1000px)
					width: 100%
					margin-top: vwm(34px)
					min-width: 100%
				&:after
					content: ''
					display: block
					width: vw(98px)
					height: vw(98px)
					background-image: url(../assets/img/play-prize.svg)
					background-size: contain
					background-repeat: no-repeat
					background-position: 50% 50%
					margin: auto
					position: absolute
					left: 0
					right: 0
					bottom: 0
					top: 0
					@media screen and (max-width: 1000px)
						width: vwm(50px)
						height: vwm(50px)
				img
					width: 100%
					display: block
				&--play
					height: vw(371px)
					@media screen and (max-width: 1000px)
						height: vwm(190px)
					&:after
						display: none !important
					iframe
						width: 100%
						height: 100%
			&-title
				font-size: vw(40px)
				color: $blue
				font-family: 'Oswald'
				line-height: vw(52px)
				text-shadow: 10px 10px 20px rgba(8, 58, 102, 0.1)
				margin-bottom: vw(12px)
				@media screen and (max-width: 1000px)
					line-height: vwm(38px)
					margin-bottom: vwm(16px)
					font-size: vwm(30px)
			&-text
				font-size: vw(14px)
				color: $blue
				font-family: 'Montserrat'
				line-height: vw(20px)
				@media screen and (max-width: 1000px)
					font-size: vwm(14px)
					line-height: vwm(20.5px)
					br
						display: none
			&-content
				margin-left: vw(50px)
				margin-top: vw(49px)
				width: vw(443px)
				@media screen and (max-width: 1000px)
					margin-left: 0
					margin-top: vwm(50px)
					width: 100%
		&__item
			display: flex
			@media screen and (max-width: 1000px)
				flex-direction: column
				padding-left: 0 !important
			&-image
				width: vw(190px)
				min-width: vw(190px)
				animation: updown
				animation-iteration-count: infinite
				animation-duration: 3s
				&--air
					animation: airplane
					animation-iteration-count: infinite
					animation-duration: 8s
				img
					width: 100%
			&-content
				width: vw(415px)
				min-width: vw(415px)
				margin-left: vw(48px)
				margin-right: vw(36px)
				@media screen and (max-width: 1000px)
					width: 100%
					min-width: 100%
					margin-left: 0
					margin-right: 0
			&-label
				font-size: vw(20px)
				font-family: 'Oswald'
				color: $blue
				font-weight: 300
				@media screen and (max-width: 1000px)
					font-size: vwm(20px)
			&-title
				font-size: vw(40px)
				color: $blue
				font-family: 'Oswald'
				@media screen and (max-width: 1000px)
					font-size: vwm(30px)
			&-text
				font-size: vw(14px)
				line-height: vw(21px)
				color: $blue
				font-family: 'Montserrat'
				a
					color: #fff
				@media screen and (max-width: 1000px)
					font-size: vwm(14px)
					line-height: vwm(20.5px)
			&--1
				padding-left: vw(26px)
				.prizes__item-image
					margin-top: vw(26px)
					@media screen and (max-width: 1000px)
						width: vwm(185px)
						text-align: center
						margin: auto
						margin-top: vwm(5px)
						transform: translateX(vwm(-7px))
				.prizes__item-content
					margin-top: vw(3px)
					@media screen and (max-width: 1000px)
						margin-top: vwm(-67px)
				.prizes__item-label
					margin-bottom: vw(13px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(16px)
				.prizes__item-title
					margin-bottom: vw(21px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(9px)
				.prizes__step--1
					@media screen and (max-width: 1000px)
						margin-left: vwm(-15px)
					.prizes__step-icon
						width: vw(106px)
						margin-top: vw(42px)
						margin-left: vw(59px)
						margin-bottom: vw(43px)
						@media screen and (max-width: 1000px)
							width: vwm(83px)
							margin-bottom: vwm(22px)
							margin-top: vwm(67px)
							margin-left: vwm(15px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(18px)
				.prizes__step--2
					.prizes__step-icon
						width: vw(100px)
						margin-top: vw(2px)
						margin-left: vw(57px)
						margin-bottom: vw(32px)
						@media screen and (max-width: 1000px)
							width: vwm(70px)
							margin-bottom: vwm(19px)
							margin-top: vwm(50px)
							margin-left: vwm(30px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(23px)
						@media screen and (max-width: 1000px)
							margin-right: 0
							transform: translateX(vwm(7px))
				.prizes__step--3
					.prizes__step-icon
						width: vw(140px)
						margin-top: vw(13px)
						margin-left: vw(38px)
						margin-bottom: vw(36px)
						@media screen and (max-width: 1000px)
							width: vwm(92px)
							margin-bottom: vwm(26px)
							margin-top: vwm(58px)
							margin-left: vwm(27px)
							margin-right: vwm(-15px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(23px)
						@media screen and (max-width: 1000px)
							transform: translateX(vwm(14px))
							width: vwm(117px)
							position: absolute
			&--2
				padding-left: vw(26px)
				@media screen and (max-width: 1000px)
					padding-bottom: vwm(45px)
				.prizes__item-image
					margin-top: vw(8px)
					@media screen and (max-width: 1000px)
						width: vwm(191px)
						text-align: center
						margin: auto
						margin-top: vwm(25px)
						transform: translateX(vwm(39px))
					img
						width: 92%
						margin-top: vw(16px)
						margin-left: vw(14px)
				.prizes__item-content
					margin-top: vw(3px)
					@media screen and (max-width: 1000px)
						margin-top: vwm(-22px)
				.prizes__item-label
					margin-bottom: vw(32px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(33px)
					color: $white
				.prizes__item-title
					margin-bottom: vw(24px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(22px)
						font-size: vwm(40px)
					color: $white
				.prizes__item-text
					color: $white
					@media screen and (max-width: 1000px)
						br
							display: none
				.prizes__step-text
					color: $white
				.prizes__step-number
					color: rgba(255, 255, 255, 0.6)
				.prizes__step:before
					background-color: rgba(255, 255, 255, 0.4)
				.prizes__step--1
					@media screen and (max-width: 1000px)
						margin-left: vwm(-15px)
					.prizes__step-icon
						width: vw(140px)
						margin-top: vw(19px)
						margin-left: vw(42px)
						margin-bottom: vw(33px)
						@media screen and (max-width: 1000px)
							width: vwm(92px)
							margin-bottom: vwm(22px)
							margin-top: vwm(64px)
							margin-left: vwm(10px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(21px)
				.prizes__step--2
					.prizes__step-icon
						width: vw(66px)
						margin-top: vw(-3px)
						margin-left: vw(78px)
						margin-bottom: vw(34px)
						@media screen and (max-width: 1000px)
							width: vwm(47px)
							margin-bottom: vwm(19px)
							margin-top: vwm(46px)
							margin-left: vwm(40px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(23px)
						@media screen and (max-width: 1000px)
							margin-right: 0
							transform: translateX(vwm(7px))
				.prizes__step--3
					.prizes__step-icon
						width: vw(140px)
						margin-top: vw(13px)
						margin-left: vw(38px)
						margin-bottom: vw(36px)
						@media screen and (max-width: 1000px)
							width: vwm(92px)
							margin-bottom: vwm(26px)
							margin-top: vwm(58px)
							margin-left: vwm(27px)
							margin-right: vwm(-15px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(28px)
						@media screen and (max-width: 1000px)
							transform: translateX(vwm(14px))
							width: vwm(117px)
							position: absolute
			&--3
				padding-left: vw(26px)
				@media screen and (max-width: 1000px)
					padding-bottom: vwm(30px)
				.prizes__item-image
					margin-top: vw(8px)
					@media screen and (max-width: 1000px)
						width: vwm(189px)
						text-align: center
						margin: auto
						margin-top: vwm(20px)
						transform: translateX(vwm(34px))
					img
						width: 66%
						margin-top: vw(16px)
						margin-left: vw(42px)
				.prizes__item-content
					margin-top: vw(3px)
					@media screen and (max-width: 1000px)
						margin-top: vwm(-17px)
				.prizes__item-label
					margin-bottom: vw(51px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(51px)
					color: $white
				.prizes__item-title
					margin-bottom: vw(24px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(22px)
						font-size: vwm(40px)
					color: $white
				.prizes__item-text
					color: $white
					@media screen and (max-width: 1000px)
						br
							display: none
				.prizes__step-text
					color: $white
				.prizes__step-number
					color: rgba(255, 255, 255, 0.6)
				.prizes__step:before
					background-color: rgba(255, 255, 255, 0.4)
				.prizes__step--1
					@media screen and (max-width: 1000px)
						margin-left: vwm(-15px)
					.prizes__step-icon
						width: vw(119px)
						margin-top: vw(11px)
						margin-left: vw(53px)
						margin-bottom: vw(44px)
						@media screen and (max-width: 1000px)
							width: vwm(79px)
							margin-bottom: vwm(20px)
							margin-top: vwm(44px)
							margin-left: vwm(17px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(19px)
				.prizes__step--2
					.prizes__step-icon
						width: vw(66px)
						margin-top: vw(19px)
						margin-left: vw(78px)
						margin-bottom: vw(42px)
						@media screen and (max-width: 1000px)
							width: vwm(44px)
							margin-bottom: vwm(19px)
							margin-top: vwm(49px)
							margin-left: vwm(42px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(21px)
						@media screen and (max-width: 1000px)
							margin-right: 0
							transform: translateX(vwm(7px))
				.prizes__step--3
					.prizes__step-icon
						width: vw(138px)
						margin-top: vw(6px)
						margin-left: vw(39px)
						margin-bottom: vw(29px)
						@media screen and (max-width: 1000px)
							width: vwm(92px)
							margin-bottom: vwm(15px)
							margin-top: vwm(41px)
							margin-left: vwm(27px)
							margin-right: vwm(-15px)
						img
							width: 100%
					.prizes__step-text
						margin-right: vw(27px)
						@media screen and (max-width: 1000px)
							transform: translateX(vwm(14px))
							width: vwm(117px)
							position: absolute
		&__steps	
			display: flex
		&__step
			width: vw(242px)
			position: relative
			@media screen and (max-width: 1000px)
				width: vwm(125px)
			&:before
				content: ''
				height: vw(100px)
				width: vw(1px)
				background-color: rgba(0, 46, 86, 0.4)
				position: absolute
				left: vw(-9px)
				top: vw(80px)
				@media screen and (max-width: 1000px)
					display: none
			&-number
				font-size: vw(40px)
				color: rgba(0, 46, 86, 0.6)
				font-family: 'Oswald'
				@media screen and (max-width: 1000px)
					display: none
			&-text
				font-size: vw(13px)
				font-family: 'Montserrat'
				font-weight: 500
				text-align: center
				color: $blue
				line-height: vw(20px)
				@media screen and (max-width: 1000px)
					font-size: vwm(10px)
					line-height: vwm(15px)
				strong
					font-weight: 700
		&__content
			&--purpure
				background-color: $purpure
				padding-top: vw(51px)
				padding-bottom: vw(49px)
			&--blue
				background-color: $lightblue
				padding-top: vw(51px)
				padding-bottom: vw(50px)
		&__note
			background-image: url(../assets/images/bg-small.png)
			background-size: cover
			background-repeat: no-repeat
			padding-top: vw(38px)
			padding-bottom: vw(18px)
			padding-left: vw(15px)
			&-title
				font-size: vw(20px)
				color: $blue
				font-family: 'Oswald'
				text-align: center
				margin-bottom: vw(25px)
				@media screen and (max-width: 1000px)
					font-size: vwm(20px)
					padding-top: vwm(25px)
					margin-bottom: vwm(16px)
			&-text
				font-size: vw(12px)
				line-height: vw(18px)
				color: $blue
				font-family: 'Montserrat'
				text-align: center
				width: 87%
				margin: auto
				@media screen and (max-width: 1000px)
					font-size: vwm(12px)
					line-height: vwm(18px)
					width: 100%
					span
						display: block
				p
					margin-bottom: vw(19px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(19px)
				strong
					font-weight: 500
				a
					color: $blue
					font-weight: 500
	.welcome
		background-image: url(../assets/images/bg-welcome.png)
		background-size: cover
		background-repeat: no-repeat
		padding-top: vw(54px)
		padding-bottom: vw(52px)
		@media screen and (max-width: 1000px)
			padding-bottom: vwm(61px)
		&__content
			display: flex
			justify-content: center
			margin-left: vw(-24px)
			@media screen and (max-width: 1000px)
				flex-direction: column
		&__avatar
			width: vw(189px)
			margin-right: vw(54px)
			margin-top: vw(3px)
			@media screen and (max-width: 1000px)
				margin: auto
				width: vwm(189px)
				padding-top: vwm(45px)
			img
				width: 100%
				border-radius: 50%
		&__title
			font-size: vw(16px)
			color: $blue
			font-weight: 600
			font-family: 'Montserrat'
			line-height: vw(25px)
			margin-bottom: vw(9px)
			@media screen and (max-width: 1000px)
				font-size: vwm(16px)
				line-height: vwm(25px)
				margin-bottom: vwm(11px)
			.color-red
				color: $red
			.color-yellow
				color: $yellow
			.color-blue
				color: $lightblue
			.color-purpure
				color: $purpure
		&__text
			font-size: vw(14px)
			line-height: vw(20px)
			font-family: 'Montserrat'
			color: rgba(0, 46, 86, 0.7)
			margin-bottom: vw(30px)
			@media screen and (max-width: 1000px)
				margin-bottom: vwm(30px)
				font-size: vwm(14px)
				line-height: vwm(20.5px)
				width: 101%
				br
					display: none
		&__info
			width: vw(700px)
			@media screen and (max-width: 1000px)
				width: 100%
				padding-left: vwm(8px)
				padding-top: vwm(20px)
		&__play
			&-content
				display: flex
				align-items: center
				@media screen and (max-width: 1000px)
					margin-left: vwm(-2px)
					margin-top: vwm(33px)
			&-icon
				width: vw(42px)
				min-width: vw(42px)
				height: vw(42px)
				border-radius: 50%
				border: 2px solid $blue
				background-image: url(../assets/img/play-main.svg)
				background-size: vw(13px)
				background-repeat: no-repeat
				background-position: 55% 50%
				margin-right: vw(12px)
				cursor: pointer
				@media screen and (max-width: 1000px)
					width: vwm(42px)
					min-width: vwm(42px)
					height: vwm(42px)
					margin-right: vwm(10px)
					background-size: vwm(13px)
				&:hover
					background-image: url(../assets/img/play-main-white.svg)
					background-color: $blue
				&--pause
					background-image: url(../assets/img/pause.svg)
					background-position: 50% 50%
					&:hover
						background-image: url(../assets/img/pause-white.svg)
						background-color: $blue
			&-line
				width: vw(630px)
				height: vw(1px)
				background-color: rgba(0, 46, 86, 0.2)
				border: 1px solid transparent
				border-radius: 20px 20px 20px 20px
				margin-top: -2px
				cursor: pointer
				position: relative
				@media screen and (max-width: 1000px)
					width: vwm(283px)
					height: 2px
					margin-left: auto
			&-progress
				width: 15%
				height: 100%
				background-color: $purpure
				border: 1px solid $purpure
				border-radius: 20px 0 0 20px
				margin-top: -2px
				@media screen and (max-width: 1000px)
					border: 1px solid $purpure
					height: 2px
					margin-top: -1px
			&-dot
				width: vw(8px)
				height: vw(8px)
				background-color: $blue
				border-radius: 50%
				position: absolute
				top: 0
				bottom: 0
				margin: auto
				left: vw(94px)
				@media screen and (max-width: 1000px)
					width: vwm(8px)
					height: vwm(8px)
	.list
		background-image: url(../assets/images/list.png)
		background-size: cover
		height: vw(721px)
		background-repeat: no-repeat
		background-color: #002E56
		transition: all 400ms
		&--1
			background-image: url(../assets/images/list.png)
		&--2
			background-image: url(../assets/images/list-2.png)
		&--3
			background-image: url(../assets/images/list-3.png)
		&--4
			background-image: url(../assets/images/list-4.png)
		@media screen and (max-width: 1000px)
			height: auto
			background: none
		&__content
			display: flex
			justify-content: space-between
			@media screen and (max-width: 1000px)
				flex-direction: column
		&__item
			width: 25%
			padding-top: vw(102px)
			padding-left: vw(24px)
			color: $white
			text-decoration: none
			height: vw(721px)
			min-height: vw(721px)
			border-bottom: 1px solid #fff
			border-right: 1px solid rgba(255, 255, 255, 0.7)
			@media screen and (max-width: 1000px)
				width: 100%
				height: vwm(333px)
				background-size: cover
				padding-top: vwm(90px)
				padding-left: vwm(17px)
			&:nth-child(1)
				@media screen and (max-width: 1000px)
					background-image: url(../assets/images/vr-m.jpg)
			&:nth-child(2)
				@media screen and (max-width: 1000px)
					background-image: url(../assets/images/rhytm-m.jpg)
					height: vwm(333px)
					padding-top: vwm(91px)
			&:nth-child(3)
				@media screen and (max-width: 1000px)
					background-image: url(../assets/images/tropa-m.jpg)
					height: vwm(333px)
					padding-top: vwm(51px)
			&:nth-child(4)
				@media screen and (max-width: 1000px)
					background-image: url(../assets/images/chudo-m.jpg)
					height: vwm(333px)
					padding-top: vwm(91px)
			&:hover
				.list__item-link span
					opacity: 1 !important
			&-title
				font-size: vw(30px)
				line-height: vw(40px)
				text-transform: uppercase
				font-family: 'Oswald'
				margin-bottom: vw(11px)
				@media screen and (max-width: 1000px)
					font-size: vwm(30px)
					line-height: vwm(40px)
			&-subtitle
				font-size: vw(20px)
				line-height: vw(30px)
				font-family: 'Montserrat'
				margin-bottom: vw(42px)
				@media screen and (max-width: 1000px)
					font-size: vwm(20px)
					padding-top: vwm(15px)
					padding-left: vwm(3px)
					line-height: 1
			&-link span
				transition: all 300ms
				font-size: vw(16px)
				opacity: 0
				font-family: 'Montserrat'
				text-decoration: underline
				color: rgba(255, 255, 255, 0.8)
				@media screen and (max-width: 1000px)
					opacity: 1
					font-size: 16px
					margin-top: 46px
					display: block
					margin-left: 3px
	.meet
		background-image: url(../assets/images/bg.png)
		background-size: cover
		background-repeat: no-repeat
		padding-top: vw(50px)
		@media screen and (max-width: 1000px)
			padding-top: vwm(50px)
			height: vwm(657px)
		&__item
			@media screen and (max-width: 1000px)
				position: absolute
				top: 0 !important
				left: 0 !important
				margin: 0 !important
		&__close
			display: block
			width: vw(20px)
			height: vw(20px)
			text-align: center
			line-height: vw(20px)
			font-size: vw(14px)
			position: absolute
			font-family: 'Montserrat'
			color: #fff
			z-index: 9999999
			right: 5px
			cursor: pointer
			top: 5px
			opacity: 0.8
			transition: all 300ms
			&:hover
				opacity: 1
			@media screen and (max-width: 1000px)
				width: vwm(20px)
				height: vwm(20px)
				line-height: vwm(20px)
				font-size: vwm(14px)
		&__modal
			position: fixed
			top: 0
			left: 0
			width: 100%
			height: 100%
			z-index: 9999999
			display: flex
			justify-content: center
			align-items: center
			&-content
				display: block
				position: relative
				z-index: 999999999999
				background-color: #fff
				border: 1px solid #fff
				width: vw(315px)
				@media screen and (max-width: 1000px)
					width: vwm(315px)
			&-text
				font-size: vw(14px)
				line-height: vw(20px)
				font-family: 'Montserrat'
				color: #002E56
				padding-top: vw(14px)
				padding-left: vw(9px)
				padding-right: vw(9px)
				@media screen and (max-width: 1000px)
					padding-top: vwm(14px)
					padding-left: vwm(9px)
					padding-right: vwm(9px)
					font-size: vwm(14px)
					line-height: vwm(20px)
				p
					margin-bottom: vw(8px)
					@media screen and (max-width: 1000px)
						margin-bottom: vwm(8px)
			&-audio
				padding-left: vw(9px)
				padding-right: vw(9px)
				margin-bottom: vw(20px)
				@media screen and (max-width: 1000px)
					padding-left: vwm(9px)
					padding-right: vwm(9px)
					margin-bottom: vwm(20px)
				.welcome__play-icon
					min-width: vw(42px)
					@media screen and (max-width: 1000px)
						min-width: vwm(42px)
				.welcome__play-line
					width: vw(212px)
					@media screen and (max-width: 1000px)
						width: vwm(242px)
			&-player
				height: vw(180px)
				@media screen and (max-width: 1000px)
						height: vwm(180px)
				iframe
					width: 100%
					height: vw(180px)
					@media screen and (max-width: 1000px)
						height: vwm(180px)
			&-video
				position: relative
				cursor: pointer
				height: vw(180px)
				@media screen and (max-width: 1000px)
						height: vwm(180px)
				&:hover
					i
						transform: scale(1.05)
				&:after
					content: ''
					display: block
					width: 100%
					height: 100%
					position: absolute
					top: 0
					left: 0
					background-color: rgba(0, 46, 86, 0.5)
				i
					position: absolute
					width: vw(45px)
					height: vw(45px)
					background-image: url(../assets/img/play-prize.svg)
					background-repeat: no-repeat
					background-size: contain
					display: block
					transition: all 300ms
					position: absolute
					left: 0
					z-index: 5
					right: 0
					top: 0
					bottom: 0
					margin: auto
					@media screen and (max-width: 1000px)
						width: vwm(46px)
						height: vwm(46px)
				img
					width: 100%
					display: block
					height: 100%
			&-image
				position: relative
				&:after
					content: ''
					display: block
					width: 100%
					height: vw(145px)
					background: linear-gradient(180deg, rgba(0, 46, 86, 0) 23.6%, rgba(0, 46, 86, 0.64) 81.3%)
					position: absolute
					bottom: 0
					@media screen and (max-width: 1000px)
						height: vwm(200px)
				img
					width: 100%
					display: block
				p
					position: absolute
					z-index: 100
					bottom: vw(10px)
					width: 100%
					text-align: center
					font-family: 'Oswald'
					font-size: vw(30px)
					line-height: vw(45px)
					text-transform: uppercase
					color: #fff
					font-weight: 600
					@media screen and (max-width: 1000px)
						font-size: vwm(30px)
						line-height: vwm(45px)
						bottom: vwm(10px)
		&__bg
			width: 100%
			height: 100%
			position: absolute
			top: 0
			cursor: pointer
			left: 0
			background-color: #002E56
			opacity: 0.8
		&__title
			font-size: vw(50px)
			font-family: 'Oswald'
			text-transform: uppercase
			color: $blue
			text-shadow: 10px 10px 20px rgba(8, 58, 102, 0.2)
			text-align: center
			margin-bottom: vw(18px)
			margin-left: vw(-4px)
			@media screen and (max-width: 1000px)
				font-size: vwm(30px)
				padding-top: vwm(6px)
		&__subtitle
			font-size: vw(20px)
			font-family: 'Montserrat'
			color: $blue
			text-align: center
			margin-left: vw(5px)
			@media screen and (max-width: 1000px)
				font-size: vwm(16px)
				width: 71%
				margin: auto
				line-height: vwm(21px)
				padding-top: vwm(2px)
		&__map
			background-image: url(../assets/images/map.png)
			background-size: vw(446px)
			background-repeat: no-repeat
			background-position: 49.7% 0
			height: vw(749px)
			margin-top: vw(-138px)
			margin-bottom: vw(-40px)
			@media screen and (max-width: 1000px)
				background-image: url(../assets/images/map-m.jpg)
				background-size: vwm(314px)
				height: vwm(535px)
				margin-top: vwm(-26px)
		&__item
			width: vw(172px)
			position: relative
			display: flex
			align-items: center
			justify-content: center
			&:hover
				&:after
					transform: scale(1.4) !important
					animation: pulseready !important
				.meet__item-image
					transform: scale(1.1)
			@media screen and (max-width: 1000px)
				//position: absolute
			&:after
				content: ''
				width: vw(21px)
				height: vw(21px)
				background-image: url(../assets/img/dot.svg)
				background-size: contain
				background-repeat: no-repeat
				position: absolute
				transition: all 300ms
				transition-delay: 0ms
				animation: pulse
				animation-iteration-count: infinite
				animation-duration: 4s
				@media screen and (max-width: 1000px)
					width: vwm(18px)
					height: vwm(18px)
			&:before
				content: ''
				width: vw(201px)
				height: 1px
				background-color: rgba(163, 35, 139, 0.65)
				position: absolute
				@media screen and (max-width: 1000px)
					display: none
			&-image
				position: relative
				margin-top: -1px
				overflow: hidden
				transform: scale(1.02)
				border: 1px solid $purpure
				transition: all 300ms
				@media screen and (max-width: 1000px)
					display: none
				img
					display: block
					transform: scale(1.05)
				&:after
					content: ''
					width: 100%
					height: 100%
					background: linear-gradient(180deg, rgba(0, 46, 86, 0) 23.6%, rgba(0, 46, 86, 0.64) 81.3%)
					position: absolute
					top: 0
					left: 0
			img
				width: 100%
			&-title
				font-size: vw(30px)
				text-transform: uppercase
				color: $white
				font-weight: 600
				font-family: 'Oswald'
				position: absolute
				@media screen and (max-width: 1000px)
					font-size: vwm(20px)
					color: $purpure
			&--1
				margin-top: vw(40px)
				margin-left: vw(21px)
				margin-bottom: vw(73px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(63px)
					margin-left: vwm(38px)
					top: vwm(64px) !important
					left: vwm(39px) !important
				&:after
					top: vw(73px)
					right: vw(-300px)
					@media screen and (max-width: 1000px)
						top: vwm(19px)
						right: vwm(0px)
				&:before
					width: vw(289px)
					top: vw(83px)
					right: vw(-288px)
			&--2
				margin-left: vw(114px)
				margin-bottom: vw(67px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(196px)
					margin-left: vwm(19px)
					top: vwm(261px) !important
					left: vwm(18px) !important
				&:after
					top: vw(103px)
					right: vw(-201px)
					@media screen and (max-width: 1000px)
						top: vwm(18px)
						right: vwm(-15px)
				&:before
					width: vw(230px)
					bottom: vw(3px)
					right: vw(-187px)
			&--3
				@media screen and (max-width: 1000px)
					margin-top: vwm(74px)
					margin-left: vwm(-19px)
					top: vwm(334px) !important
					left: vwm(-20px) !important
				&:after
					top: vw(0px)
					right: vw(-271px)
					@media screen and (max-width: 1000px)
						top: vwm(18px)
						right: vwm(-15px)
				&:before
					width: vw(261px)
					top: vw(10px)
					right: vw(-261px)
			&--4
				margin-bottom: vw(39px)
				margin-left: vw(-93px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(56px)
					margin-left: vwm(0px)
					top: vwm(57px) !important
					left: vwm(0px) !important
				&:after
					top: vw(103px)
					left: vw(-239px)
					@media screen and (max-width: 1000px)
						top: vwm(18px)
						left: vwm(-14px)
				&:before
					width: vw(234px)
					bottom: vw(3px)
					left: vw(-230px)
			&--5
				margin-bottom: vw(39px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(111px)
					margin-left: vwm(-8px)
					top: vwm(167px) !important
					left: vwm(-8px) !important
				&:after
					top: vw(72px)
					left: vw(-333px)
					@media screen and (max-width: 1000px)
						top: vwm(18px)
						left: vwm(-8px)
				&:before
					width: vw(323px)
					bottom: vw(35px)
					left: vw(-321px)
			&--6
				margin-bottom: vw(40px)
				margin-left: vw(-105px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(125px)
					margin-left: vwm(-8px)
					transform: translateX(vwm(16px))
					top: vwm(294px) !important
					left: vwm(-7px) !important
				&:after
					top: vw(59px)
					left: vw(-209px)
					@media screen and (max-width: 1000px)
						top: vwm(18px)
						left: vwm(-8px)
				&:before
					bottom: vw(48px)
					left: vw(-196px)
			&--7
				margin-left: vw(-270px)
				@media screen and (max-width: 1000px)
					margin-top: vwm(163px)
					margin-left: vwm(-8px)
					transform: translateX(vwm(-157px))
					top: vwm(457px) !important
					left: vwm(-9px) !important
				&:after
					top: vw(84px)
					left: vw(-254px)
					@media screen and (max-width: 1000px)
						top: vwm(19px)
						left: vwm(-22px)
				&:before
					width: vw(243px)
					bottom: vw(23px)
					left: vw(-240px)
		&__content
			display: flex
			justify-content: space-between
			padding-left: vw(166px)
			padding-right: vw(109px)
			padding-top: vw(78px)
	.page
		position: relative
		overflow: hidden
	.fp-viewing-3 .page-home
		.header__menu-item a
			color: $blue !important
		.header__menu-item--blue a
			color: $blue !important
		.header__right-logo a
			background-image: url(../assets/img/lenta.svg)
		.header--white .header__right-label
			color: #000
		.header__logo a
			background-image: url(../assets/img/logo-dark.svg)
		.header__right-logo a
			background-image: url(../assets/img/lenta.svg)
		.social__item--telegram
			background-image: url(../assets/img/telegram.svg)
		.social__item--ok
			background-image: url(../assets/img/ok.svg)
		.social__item--twitter
			background-image: url(../assets/img/twitter.svg)
		.social__item--vk
			background-image: url(../assets/img/vk.svg)
		.social__item--facebook
			background-image: url(../assets/img/facebook.svg)
		.social__item--like
			background-image: url(../assets/img/like-line.svg)
			&:hover
				background-image: url(../assets/img/like.svg)
	.fp-viewing-2 .page-home, .fp-viewing-1 .page-home
		.header__menu-item a
			color: $white !important
		.header__menu-item--blue a
			color: $white !important
		.header__right-logo a
			background-image: url(../assets/img/lenta-light.svg)
		.header--white .header__right-label
			color: $white
		.header__logo a
			background-image: url(../assets/img/logo.svg)
		.header__right-logo a
			background-image: url(../assets/img/lenta-light.svg)
		.social__item--telegram
			background-image: url(../assets/img/telegram-light.svg)
		.social__item--ok
			background-image: url(../assets/img/ok-light.svg)
		.social__item--twitter
			background-image: url(../assets/img/twitter-light.svg)
		.social__item--vk
			background-image: url(../assets/img/vk-light.svg)
		.social__item--facebook
			background-image: url(../assets/img/facebook-light.svg)
		.social__item--like
			background-image: url(../assets/img/like-light-line.svg)
			&:hover
				background-image: url(../assets/img/like-light.svg)
	.fp-viewing-1 .page-home
		.social__item--telegram
			background-image: url(../assets/img/telegram.svg)
		.social__item--ok
			background-image: url(../assets/img/ok.svg)
		.social__item--twitter
			background-image: url(../assets/img/twitter.svg)
		.social__item--vk
			background-image: url(../assets/img/vk.svg)
		.social__item--facebook
			background-image: url(../assets/img/facebook.svg)
		.social__item--like
			background-image: url(../assets/img/like-line.svg)
			&:hover
				background-image: url(../assets/img/like.svg)

	.fp-auto-height
		height: auto !important
		.fp-tableCell
			height: auto !important

	@keyframes airplane
		0%
			transform: translateY(0px) translateX(0px)
		20%
			transform: translateY(20px) translateX(-10px)
		40%
			transform: translateY(0px) translateX(0px)
		60%
			transform: translateY(20px) translateX(-15px)
		80%
			transform: translateY(20px) translateX(-5px)
		100%
			transform: translateY(0px) translateX(0px)
	@keyframes updown
		0%
			transform: translateY(0px)
		50%
			transform: translateY(20px)
		100%
			transform: translateY(0px)
	@keyframes pulse
		0%
			transform: scale(0.95)
		40%
			transform: scale(1.1)
		60%
			transform: scale(0.95)
		80%
			transform: scale(1.1)
		100%
			transform: scale(0.95)
	@keyframes pulseready
		0%
			transform: scale(1.4)
		100%
			transform: scale(1.4)
	@media screen and (max-width: 1600px) and (min-width: 1300px) and (max-height: 700px)
		.button--main
			bottom: vw(60px)
		.main__text
			margin-top: vw(20px)
		#map
			transform: scale(0.85)
	@media screen and (max-width: 1600px) and (min-width: 1100px) and (max-height: 700px)
		.button--main
			bottom: vw(60px)
		.main__text
			margin-top: vw(20px)
		#map
			transform: scale(0.85)
	@media screen and (max-width: 1000px)
		.button--main	
			top: vwm(470px) !important

</style>